import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class PlannedActualService {

  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }
  
  //function to planned detail from http service
  getPlanedDetail(role): Observable<any> {
    const data = {
      'Empno': role
    };
    return this.httpService.post(`rm/plannedActual`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  //function to handle error data
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}




// WEBPACK FOOTER //
// ./src/app/admin/planed-actual/planned-actual.service.ts